export default function Footer() {
  return (
    <footer className="border-t border-ink/10 py-12 md:py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col gap-7">
        <div className="flex flex-wrap items-center justify-between gap-5">
          <img
            src="/logo-ocean-star.png"
            alt="Ocean Star — Assessoria Eleitoral"
            className="h-9 w-auto"
            data-testid="footer-logo"
          />
          <span className="font-mono text-[11px] text-ink/55">CNPJ 68.764.874/0001-59</span>
        </div>
        <p className="font-mono text-[11px] leading-[1.8] text-ink/60 max-w-3xl" data-testid="footer-disclaimer">
          Esta empresa não é um órgão público e não possui vínculo com o TRE, o
          TSE ou qualquer unidade da Justiça Eleitoral. Certidões e serviços
          eleitorais são gratuitos e de emissão exclusiva da Justiça Eleitoral;
          o valor cobrado refere-se unicamente à assessoria e orientação
          prestada por esta empresa.
        </p>
        <div className="flex flex-wrap justify-between gap-3 border-t border-ink/10 pt-6">
          <span className="font-mono text-[10.5px] text-ink/55">© 2026 — Todos os direitos reservados</span>
          <span className="font-mono text-[10.5px] text-ink/55 uppercase tracking-[0.16em]">
            Brasileiros no exterior · Documental
          </span>
        </div>
      </div>
    </footer>
  );
}
